// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import VueMoment from 'vue-moment'
import App from './App'
import router from './router'
import i18n from './i18n'
import {generateKey} from '@/mixins/keyGenerator'

import store from './store/'

import VeeValidate from 'vee-validate'
import moment from 'moment'

moment.locale(navigator.language)

Vue.use(VeeValidate, {
  inject: false
})

Vue.use(Router)
Vue.use(VueMoment)

Vue.mixin({
  data: () => ({generateKey})
})

Vue.config.productionTip = false

/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: {App},
  template: '<App/>'
})

export default app



// WEBPACK FOOTER //
// ./src/main.js